import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PersonModel from './person';
import type ComponentReviewCommentModel from './component-review-comment';

export default class ComponentReviewThreadModel extends Model {
  @attr declare reviewId: string;
  @attr declare pagePath: string;
  @attr declare status: 'open' | 'resolved' | 'wontfix';
  @attr declare screenshotUrl: string | null;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  @belongsTo('person', { async: false, inverse: null })
  declare createdBy: PersonModel;

  @hasMany('component-review-comment', { async: false, inverse: 'thread' })
  declare comments: ComponentReviewCommentModel[];

  get isOpen() {
    return this.status === 'open';
  }

  get isResolved() {
    return this.status === 'resolved';
  }

  get commentCount() {
    return this.comments?.length ?? 0;
  }

  [Type] = 'component-review-thread' as const;
}
